module.exports = __webpack_public_path__ + "img/romania.393af141.svg";